import axios from 'axios'
import { Message } from 'element-ui'

const adminRequest = axios.create({
  baseURL: '/api',
  timeout: 15000
})

let unauthorizedHandling = false

function handleUnauthorized(message = '登录已过期，请重新登录') {
  localStorage.removeItem('admin_token')
  localStorage.removeItem('admin_username')
  if (!unauthorizedHandling) {
    unauthorizedHandling = true
    Message.error(message)
    window.location.hash = '#/login'
    setTimeout(() => {
      unauthorizedHandling = false
    }, 2000)
  }
}

adminRequest.interceptors.request.use(
  config => {
    const token = localStorage.getItem('admin_token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

adminRequest.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      if (res.code === 401) {
        handleUnauthorized(res.message || '登录已过期，请重新登录')
      } else {
        Message.error(res.message || '请求失败')
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    const status = error.response && error.response.status
    if (status === 401) {
      const data = error.response.data || {}
      handleUnauthorized(data.message || '登录已过期，请重新登录')
    } else {
      Message.error(error.message || '网络错误')
    }
    return Promise.reject(error)
  }
)

// 获取管理员列表
export function getAdminList(params) {
  return adminRequest({
    url: '/admin/list',
    method: 'get',
    params
  })
}

// 获取管理员分页
export function getAdminPage(params) {
  return adminRequest({
    url: '/admin/page',
    method: 'get',
    params
  })
}

// 获取管理员详情
export function getAdminById(id) {
  return adminRequest({
    url: '/admin/' + id,
    method: 'get'
  })
}

// 创建管理员
export function createAdmin(data) {
  return adminRequest({
    url: '/admin',
    method: 'post',
    data
  })
}

// 更新管理员
export function updateAdmin(id, data) {
  return adminRequest({
    url: '/admin/' + id,
    method: 'put',
    data
  })
}

// 删除管理员
export function deleteAdmin(id) {
  return adminRequest({
    url: '/admin/' + id,
    method: 'delete'
  })
}

// 更新管理员状态
export function updateAdminStatus(id, status) {
  return adminRequest({
    url: '/admin/' + id + '/status',
    method: 'put',
    params: { status }
  })
}

// 获取当前用户可创建的角色类型
export function getAllowedRoles() {
  return adminRequest({
    url: '/admin/allowed-roles',
    method: 'get'
  })
}
